<div class="org-type-selector">
  <mat-label class="field-label">{{ label }}<span class="required-star">*</span></mat-label>
  <mat-form-field appearance="outline" class="w-100">
    <input
      matInput
      [placeholder]="placeholder"
      [formControl]="inputCtrl"
      [matAutocomplete]="orgAuto"
      [errorStateMatcher]="errorStateMatcher"
      autocomplete="off"
      (keydown)="Space($event)"
      (input)="onInput()"
      (blur)="onBlur()" />

    <mat-autocomplete
      #orgAuto="matAutocomplete"
      [displayWith]="displayOrgType.bind(this)"
      (optionSelected)="onOptionSelected($event.option.value)">
      <mat-option *ngFor="let type of filteredOrgTypes$ | async" [value]="type">
        <span style="display:flex; align-items:center; gap:8px;">
          <span
            style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
            [matTooltip]="type.name"
            matTooltipPosition="before">
            {{ type.name }}
          </span>
          <mat-icon
            *ngIf="getOrgTypeTooltip(type.name)"
            [matTooltip]="getOrgTypeTooltip(type.name)"
            matTooltipPosition="below"
            (click)="$event.stopPropagation()">
            info_outline
          </mat-icon>
        </span>
      </mat-option>
    </mat-autocomplete>

    <mat-hint class="info" *ngIf="isCustomOrgType && hintText">{{ hintText }}</mat-hint>

    <mat-error class="alert-danger " *ngIf="parentControl?.errors?.['required']">
      Organisation type is required.
    </mat-error>
    <mat-error class="alert-danger " *ngIf="parentControl?.errors?.['maxlength']">
      Maximum 15 characters allowed.
    </mat-error>
  </mat-form-field>
</div>
